import { getLongDateTime } from 'helpers';
import { useIncentiveCampaign } from 'hooks';

import { useLoyaltyIncentiveCampaign } from './useLoyaltyIncentiveCampaign';

export const useRanking = () => {
  const { ranking } = useIncentiveCampaign;
  const { campaignId } = useLoyaltyIncentiveCampaign();
  const { data, ...rest } = ranking.useQuery(campaignId);
  const lastUpdate = data?.lastUpdate ? getLongDateTime(data?.lastUpdate) : null;

  return {
    data,
    lastUpdate,
    ...rest,
  };
};
